import { render, staticRenderFns } from "./FuncionanlidadeExclusiva.vue?vue&type=template&id=bf0f54a4"
import script from "./FuncionanlidadeExclusiva.vue?vue&type=script&lang=js"
export * from "./FuncionanlidadeExclusiva.vue?vue&type=script&lang=js"
import style0 from "./FuncionanlidadeExclusiva.vue?vue&type=style&index=0&id=bf0f54a4&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports